module.exports = __webpack_public_path__ + "img/can.6e6c5ad5.svg";